import { AnimatePresence, motion } from "framer-motion";
import { FC, ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionWrapperProps {
  children: ReactNode;
}

/**
 * Transition de page (règle projet : animations de transition entre routes).
 * Le `key` sur le pathname est indispensable : sans lui, AnimatePresence ne
 * rejoue jamais l'animation lors d'un changement de route.
 */
export const PageTransitionWrapper: FC<PageTransitionWrapperProps> = ({
  children,
}) => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        className="w-full h-full overflow-y-auto"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.28,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
